import React, { useState } from 'react';
import { CSVLink } from 'react-csv';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import './TauriSummary2Visual.css';

const TauriSummary2Visual = ({ chartConfig, chartData, chartPalettes }) => {
    const [exportToggleOpen, setExportToggleOpen] = useState(false);

    if (!chartData || Object.keys(chartData).length === 0) {
        return <div className="no-records-container">There are no records to display</div>;
    }

    const exportToggle = () => setExportToggleOpen(!exportToggleOpen);

    const handleCopyToClipboard = () => {
        const formattedData = chartData.map(({ TotalInvoices, ReceivedPayment, AppliedPayment, OverPayment, BouncedCheck, Returns, Deductions, Adjustments, CurrentReceivables }) => ({
            TotalInvoices,
            ReceivedPayment,
            AppliedPayment,
            OverPayment,
            BouncedCheck,
            Returns,
            Deductions,
            Adjustments,
            CurrentReceivables,
        }));

        const header = ["Total Invoices", "Received Payment", "Applied Payment", "Over Payment", "Bounced Check", "Returns", "Deductions", "Adjustments", "Current Receivables"]

        const dataString = [header.join("\t"), ...formattedData.map(row => Object.values(row).join("\t"))].join("\n");

        navigator.clipboard.writeText(dataString).catch(err => {
            console.error('Failed to copy data:', err);
        });
    };

    const formatNumber = (num) => {
        if (num >= 1e9) {
            return (num / 1e9).toFixed(2) + 'B';
        } else if (num >= 1e6) {
            return (num / 1e6).toFixed(2) + 'M';
        } else if (num >= 1e3) {
            return (num / 1e3).toFixed(2) + 'K';
        } else {
            return num.toString();
        }
    };

    const exportData = chartData.map(({ TotalInvoices, ReceivedPayment, AppliedPayment, OverPayment, BouncedCheck, Returns, Deductions, Adjustments, CurrentReceivables }) => ({
        TotalInvoices,
        ReceivedPayment,
        AppliedPayment,
        OverPayment,
        BouncedCheck,
        Returns,
        Deductions,
        Adjustments,
        CurrentReceivables,
    }));

    const { TotalInvoices, ReceivedPayment, AppliedPayment, OverPayment, BouncedCheck, Returns, Deductions, Adjustments, CurrentReceivables } = chartData[0];

    return (
        <div className="chart-content">
            <div className='mt-5'>
                <Dropdown isOpen={exportToggleOpen} toggle={exportToggle} className="taurisummary-toolbar" style={{ position: 'absolute', right: '0' }}>
                    <DropdownToggle tag="span">
                        <img
                            src={process.env.PUBLIC_URL + "/Images/charm--menu-hamburger.svg"}
                            className='dropdown-img'
                            alt="Icon"
                        />
                    </DropdownToggle>

                    <DropdownMenu right>
                        <DropdownItem onClick={handleCopyToClipboard}>
                            Copy to clipboard
                        </DropdownItem>
                        <DropdownItem>
                            <CSVLink data={exportData} filename={`${chartConfig.title}.csv`}>
                                Download CSV
                            </CSVLink>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <div className="row mb-4">
                    <div className="col-6">
                        <p className='m-0' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.875rem' }}>Total Invoices</p>
                        <p className='fw-bold m-0' style={{ fontFamily: 'Lato-Light', fontSize: '1.6875rem', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {TotalInvoices !== undefined ? formatNumber(TotalInvoices) : 0}
                        </p>
                    </div>
                    <div className="col-6 ">
                        <p className='m-0' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.875rem' }}>Bounced Check</p>
                        <p className='fw-bold m-0'
                            style={{
                                fontFamily: 'Lato-Light',
                                fontSize: '1.6875rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                            {BouncedCheck !== undefined ? formatNumber(BouncedCheck) : 0}
                        </p>
                    </div>
                </div>
                <div className='row mb-4'>
                    <div className="col-6">
                        <p className='m-0' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.875rem' }}>Over-Payments</p>
                        <p className='fw-bold m-0' style={{ fontFamily: 'Lato-Light', fontSize: '1.6875rem', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {OverPayment !== undefined ? formatNumber(OverPayment) : 0}
                        </p>
                    </div>
                    <div className="col-6">
                        <p className='m-0' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.875rem' }}>Returns</p>
                        <p className='fw-bold m-0'
                            style={{
                                fontFamily: 'Lato-Light',
                                fontSize: '1.6875rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                            {Returns !== undefined ? formatNumber(Returns) : 0}
                        </p>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className="col-6">
                        <p className='m-0' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.875rem' }}>Adjustments</p>
                        <p className='fw-bold m-0' style={{ fontFamily: 'Lato-Light', fontSize: '1.6875rem', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {Adjustments !== undefined ? formatNumber(Adjustments) : 0}
                        </p>
                    </div>
                    <div className="col-6">
                        <p className='m-0' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.875rem' }}>Deductions</p>
                        <p className='fw-bold m-0'
                            style={{
                                fontFamily: 'Lato-Light',
                                fontSize: '1.6875rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                            {Deductions !== undefined ? formatNumber(Deductions) : 0}
                        </p>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className="col-6">
                        <p className='m-0' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.875rem' }}>Received Payment</p>
                        <p className='fw-bold m-0' style={{ fontFamily: 'Lato-Light', fontSize: '1.6875rem', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {ReceivedPayment !== undefined ? formatNumber(ReceivedPayment) : 0}
                        </p>
                    </div>
                    <div className="col-6">
                        <p className='m-0' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.875rem' }}>Applied Payment</p>
                        <p className='fw-bold m-0'
                            style={{
                                fontFamily: 'Lato-Light',
                                fontSize: '1.6875rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                            {AppliedPayment !== undefined ? formatNumber(AppliedPayment) : 0}
                        </p>
                    </div>
                </div>
                <div className='row mt-4'>
                    <div className="col-12">
                        <p className='m-0' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.875rem' }}>Current Receivables</p>
                        <p className='fw-bold m-0' style={{ fontFamily: 'Lato-Light', fontSize: '1.6875rem', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {CurrentReceivables !== undefined ? formatNumber(CurrentReceivables) : 0}
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default TauriSummary2Visual;
